export interface DeleteUserRequest {
  id: string
}

export function DeleteUserRequestToJSON(value: DeleteUserRequest): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}
